import api from "@/conf/js/api";

export default {

    xhr: null,
    loading: false,
    oloaded: 0,
    ot: null,
    successFun: null,
    /**
     * 开始处理
     * @param files
     * @param upload_type
     * @param successFun
     */
    handle(files, upload_type, successFun) {

        this.successFun = successFun;
        this.createTimeBox();
        let fd = new FormData();
        fd.append("file", files);
        fd.append("upload_type", upload_type);
        if (window.XMLHttpRequest)
            this.xhr = new XMLHttpRequest();
        else if (window.ActiveXObject)
            this.xhr = new ActiveXObject("Microsoft.XMLHTTP");
        if (this.xhr == null) {
            return api.alert("Your browser does not support XMLHTTP.");
        }
        api.loading()
        api.hideAlert();
        // xhr.upload.addEventListener("progress", progressFunction, false);
        this.xhr.upload.onprogress = this.progressFunction;//【上传进度调用方法实现】
        //上传开始执行方法
        this.xhr.upload.onloadstart = function () {
            this.ot = new Date().getTime();   //设置上传开始时间
            this.oloaded = 0;//设置上传开始时，以上传的文件大小为0
        };
        this.xhr.addEventListener("load", function (evt) {
            let json = eval('(' + evt.target.responseText + ')');
            if (json.code === 200) {
                if (successFun)
                    successFun(json.data)
            } else {
                api.alert(json.msg);
            }
            document.getElementById("upload-time").innerHTML = "";
            api.hideLoading();

        }, false);
        this.xhr.addEventListener("error", this.uploadFailed, false);
        this.xhr.addEventListener("abort", this.uploadCanceled, false);
        this.xhr.open("POST", "https://api.1dq.com/v1/Uploads");
        this.xhr.setRequestHeader("clientType", "APP");
        this.xhr.send(fd);
    },


    /**
     * 上传失败
     * @param evt
     */
    uploadFailed(evt) {
        api.alert("客户端上传失败");
        document.getElementById("upload-time").innerHTML = "";
        api.hideLoading();
    }
    ,
    /**
     * 已经取消上传
     * @param evt
     */
    uploadCanceled(evt) {
        api.alert("已经取消上传");
        document.getElementById("upload-time").innerHTML = "";
        api.hideLoading();
    }
    ,
    /**
     * 上传进度实现方法，上传过程中会频繁调用该方法
     * @param evt
     */
    progressFunction(evt) {

        // let progressBar = document.getElementById("progressBar");
        // let percentageDiv = document.getElementById("percentage");
        // // event.total是需要传输的总字节，event.loaded是已经传输的字节。如果event.lengthComputable不为真，则event.total等于0
        // if (evt.lengthComputable) {//
        //     console.log(evt.loaded);
        //     progressBar.max = evt.total;
        //     progressBar.value = evt.loaded;
        //     percentageDiv.innerHTML = Math.round(evt.loaded / evt.total * 100) + "%";
        //     console.log(Math.round(evt.loaded / evt.total * 100) + "%");
        // }

        let time = document.getElementById("upload-time");
        let nt = new Date().getTime();//获取当前时间
        let pertime = (nt - this.ot) / 1000; //计算出上次调用该方法时到现在的时间差，单位为s
        this.ot = new Date().getTime(); //重新赋值时间，用于下次计算
        let perload = evt.loaded - this.oloaded; //计算该分段上传的文件大小，单位b
        this.oloaded = evt.loaded;//重新赋值已上传文件大小，用以下次计算
        //上传速度计算
        let speed = perload / pertime;//单位b/s
        let bspeed = speed;
        let units = 'b/s';//单位名称
        if (speed / 1024 > 1) {
            speed = speed / 1024;
            units = 'k/s';
        }
        if (speed / 1024 > 1) {
            speed = speed / 1024;
            units = 'M/s';
        }
        speed = speed.toFixed(1);
        //剩余时间
        let resttime = ((evt.total - evt.loaded) / bspeed).toFixed(1);
        time.innerHTML = '上传速度：' + speed + units + '<br />剩余时间：' + resttime + 's';
        if (bspeed === 0) time.innerHTML = '上传已取消';
    },

    createTimeBox() {

        try {
            document.getElementById("upload-time").innerHTML;
        } catch (err) {
            let div = document.createElement("div");
            div.id = "upload-time";
            div.style.position = "fixed"
            div.style.top = "50px"
            div.style.left = "47%"
            div.style.textAlign = "center"

            document.body.appendChild(div);
        }

    }

}